// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portal-drop-down {
   position: fixed;
   background-color: var(--popup-bg);
   border: var(--border);
   border-radius: var(--border-radius);
   padding: var(--padding-sm);
   z-index: 2;
   overflow: auto;
   max-height: 40dvh;
   max-width: 100dvw;
   display: flex;
   flex-direction: column;
   align-items: center;
}

.portal-drop-down .x-out-div {
   display: none;
}

.portal-drop-down .dialog-dropdown .x-out-div {
   display: flex;
}

.portal-drop-down .x-out-div button {
   margin: 0;
   background: inherit;
}


.portal-drop-down:focus-visible {
   outline: var(--outline-focus-visible)
}

.portal-drop-down.drop-down-in-modal {
   z-index: 4;
}

.drop-down-trigger {
   position: relative;
}

.default-menu-style {
   display: flex;
   flex-direction: column;
   align-items: baseline;
}

.default-menu-style > button, .default-menu-style > a{
   display: flex;
   padding: var(--padding-sm) var(--padding);
   margin: 0;
   height: 32px;
   width: 100%;
   cursor: pointer;
   text-decoration: none;
   border: none;
   white-space: nowrap;
   border-radius: 0;
   background: none;
   color: var(--text);
   justify-content: flex-start;
   align-items: center;
}

.default-menu-style > a:hover{
   background-color: var(--button-primary-hovered);
   text-decoration: none;
   color: var(--text)
}

@media (max-width: 769px) and (orientation: portrait), 
(max-height: 769px) and (orientation: landscape) {
   .default-menu-style > button, .default-menu-style > a{
      height: 40px;
      min-height: 40px;
   }

   .portal-drop-down .x-out-div {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
   }

   .portal-drop-down {
      max-height: unset;
      max-width: unset;
      border: unset;
      border-radius: unset;
   }
}
`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLDropDown/ECLDropDown.css"],"names":[],"mappings":"AAAA;GACG,eAAe;GACf,iCAAiC;GACjC,qBAAqB;GACrB,mCAAmC;GACnC,0BAA0B;GAC1B,UAAU;GACV,cAAc;GACd,iBAAiB;GACjB,iBAAiB;GACjB,aAAa;GACb,sBAAsB;GACtB,mBAAmB;AACtB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,SAAS;GACT,mBAAmB;AACtB;;;AAGA;GACG;AACH;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,qBAAqB;AACxB;;AAEA;GACG,aAAa;GACb,yCAAyC;GACzC,SAAS;GACT,YAAY;GACZ,WAAW;GACX,eAAe;GACf,qBAAqB;GACrB,YAAY;GACZ,mBAAmB;GACnB,gBAAgB;GAChB,gBAAgB;GAChB,kBAAkB;GAClB,2BAA2B;GAC3B,mBAAmB;AACtB;;AAEA;GACG,+CAA+C;GAC/C,qBAAqB;GACrB;AACH;;AAEA;;GAEG;MACG,YAAY;MACZ,gBAAgB;GACnB;;GAEA;MACG,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,yBAAyB;GAC5B;;GAEA;MACG,iBAAiB;MACjB,gBAAgB;MAChB,aAAa;MACb,oBAAoB;GACvB;AACH","sourcesContent":[".portal-drop-down {\r\n   position: fixed;\r\n   background-color: var(--popup-bg);\r\n   border: var(--border);\r\n   border-radius: var(--border-radius);\r\n   padding: var(--padding-sm);\r\n   z-index: 2;\r\n   overflow: auto;\r\n   max-height: 40dvh;\r\n   max-width: 100dvw;\r\n   display: flex;\r\n   flex-direction: column;\r\n   align-items: center;\r\n}\r\n\r\n.portal-drop-down .x-out-div {\r\n   display: none;\r\n}\r\n\r\n.portal-drop-down .dialog-dropdown .x-out-div {\r\n   display: flex;\r\n}\r\n\r\n.portal-drop-down .x-out-div button {\r\n   margin: 0;\r\n   background: inherit;\r\n}\r\n\r\n\r\n.portal-drop-down:focus-visible {\r\n   outline: var(--outline-focus-visible)\r\n}\r\n\r\n.portal-drop-down.drop-down-in-modal {\r\n   z-index: 4;\r\n}\r\n\r\n.drop-down-trigger {\r\n   position: relative;\r\n}\r\n\r\n.default-menu-style {\r\n   display: flex;\r\n   flex-direction: column;\r\n   align-items: baseline;\r\n}\r\n\r\n.default-menu-style > button, .default-menu-style > a{\r\n   display: flex;\r\n   padding: var(--padding-sm) var(--padding);\r\n   margin: 0;\r\n   height: 32px;\r\n   width: 100%;\r\n   cursor: pointer;\r\n   text-decoration: none;\r\n   border: none;\r\n   white-space: nowrap;\r\n   border-radius: 0;\r\n   background: none;\r\n   color: var(--text);\r\n   justify-content: flex-start;\r\n   align-items: center;\r\n}\r\n\r\n.default-menu-style > a:hover{\r\n   background-color: var(--button-primary-hovered);\r\n   text-decoration: none;\r\n   color: var(--text)\r\n}\r\n\r\n@media (max-width: 769px) and (orientation: portrait), \r\n(max-height: 769px) and (orientation: landscape) {\r\n   .default-menu-style > button, .default-menu-style > a{\r\n      height: 40px;\r\n      min-height: 40px;\r\n   }\r\n\r\n   .portal-drop-down .x-out-div {\r\n      width: 100%;\r\n      display: flex;\r\n      flex-direction: row;\r\n      justify-content: flex-end;\r\n   }\r\n\r\n   .portal-drop-down {\r\n      max-height: unset;\r\n      max-width: unset;\r\n      border: unset;\r\n      border-radius: unset;\r\n   }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
